function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isDefined from "../Core/isDefined";
import i18next from "i18next";
export default class ConsoleAnalytics {
  constructor() {
    // either set enableConsoleAnalytics here to true, or pass true
    // in `configParameters.enableConsoleAnalytics` for verbose app analytics.
    _defineProperty(this, "enableConsoleAnalytics", false);
  }
  start(configParameters) {
    if (configParameters.googleAnalyticsKey || configParameters.googleAnalyticsOptions) {
      console.log(i18next.t("core.consoleAnalytics.logStartedWithGAParameters"));
    }
    if (isDefined(configParameters.enableConsoleAnalytics)) {
      console.log(i18next.t("core.consoleAnalytics.started"));
      this.enableConsoleAnalytics = configParameters.enableConsoleAnalytics;
    } else if (!isDefined(configParameters.enableConsoleAnalytics) || !configParameters.enableConsoleAnalytics) {
      console.log(i18next.t("core.consoleAnalytics.startedNoenableConsoleAnalytics"));
    }
  }
  logEvent(category, action, label, value) {
    if (this.enableConsoleAnalytics) {
      const labelString = isDefined(label) ? " Label: " + label : "";
      const valueString = isDefined(value) ? " Value: " + value : "";
      console.log("** Event ** Category: " + category + " Action: " + action + labelString + valueString);
    }
  }
}